<template lang='pug'>
v-app#inspire.app.dashboard
	app-drawer.app--drawer
	app-toolbar.app--toolbar(:visible="showToolbar")
	v-main
		// Page Header
		page-header(v-if='currentRouterPath')
		.page-wrapper.mx-0
			router-view(@emitsavePath='savePath')
		// App Footer
		scroll_top_button(:visible='!showToolbar')

		// Alert Component
		alert(
			:show="alertShow"
			:text="alertText"
			:type="alertType"
			@close="closeAlert"
		)

		side_drawer(ref='side_drawer')

</template>

<script>
import _ from 'lodash';
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import PageHeader from '@/components/PageHeader';
import scroll_top_button from '@/components/scroll_top_button';
import Alert from '@/components/alert';
import side_drawer from '@/components/side_drawer';

import throttle from 'lodash.throttle';
import { mapActions, mapGetters } from 'vuex';
import { errorLogger } from '@/util/logger';

export default {
	components: {
		'app-drawer': AppDrawer,
		'app-toolbar': AppToolbar,
		'page-header': PageHeader,
		scroll_top_button,
		Alert,
		side_drawer,
	},
	computed: {
		...mapGetters(['getBreadShow', 'getOperatorDefaultRouter']),
	},
	data() {
		return {
			windowsWidth: '',
			// lastScrollY: 0,
			showToolbar: true,
			showDrawer: '',
			currentRouterPath: true,
			// Alert 相關狀態
			alertShow: false,
			alertText: '',
			alertType: 'info',
		};
	},
	methods: {
		...mapActions(['setDrawerStatus', 'setBreadShow', 'setOperatorDefaultRouter']),
		savePath(path) {
			let lastSeachPage = [];
			let content = {
				path: path,
			};
			if (localStorage.getItem('lastSeachPage')) {
				lastSeachPage = JSON.parse(localStorage.getItem('lastSeachPage'));
				if (_.filter(lastSeachPage, { path: path }).length !== 0) {
					lastSeachPage = _.reject(lastSeachPage, { path: path });
				} else if (lastSeachPage.length >= 5) {
					lastSeachPage.pop();
				}
			}
			lastSeachPage.unshift(content);
			localStorage.setItem('lastSeachPage', JSON.stringify(lastSeachPage));
		},
		handleResize() {
			this.windowsWidth = window.innerWidth;
			// 不再根据窗口大小自动设置菜单显示状态
			// 保持当前状态，让用户通过汉堡按钮控制
		},
		on_scroll() {
			if(window.innerWidth >= 960){
				this.showToolbar = true;
				return;
			}
			this.showToolbar = (window.scrollY <= 600 ? true : false);

			// const currentScrollY = window.scrollY;

			// if (currentScrollY > this.lastScrollY + 5)
			// 	this.showToolbar = false;
			// else if (currentScrollY < this.lastScrollY - 5)
			// 	this.showToolbar = true;

			// this.lastScrollY = currentScrollY;
		},
		// 統一的 Alert 顯示方法
		showAlert(type, message) {
			this.alertType = type;
			this.alertText = message;
			this.alertShow = true;
		},
		// 關閉 Alert
		closeAlert() {
			this.alertShow = false;
			this.alertText = '';
		},
		// 錯誤處理
		on_error(errorMessage) {
			const message = errorMessage || this.$t('error.apiError');
			errorLogger('error', message);
			this.showAlert('error', message);
		},
		// 警告處理
		on_warning(warningMessage) {
			const message = warningMessage || this.$t('warning.defaultWarning');
			errorLogger('warning', message);
			this.showAlert('warning', message);
		},
		// 資訊處理
		on_info(infoMessage) {
			const message = infoMessage || this.$t('info.defaultInfo');
			this.showAlert('info', message);
		},
		on_side_drawer(drawer_params) {
			this.$refs.side_drawer.trigger_drawer(drawer_params);
		},
	},
	created() {
		this.$vuetify.theme.dark = true;
	},
	mounted() {
		this.$event_bus.$on('emit_error', this.on_error);
		this.$event_bus.$on('emit_warning', this.on_warning);
		this.$event_bus.$on('emit_info', this.on_info);
		this.$event_bus.$on('emit_side_drawer', this.on_side_drawer);

		this.handleResize();
		// 默认菜单为关闭状态
		this.showDrawer = false;
		this.setDrawerStatus(this.showDrawer);

		if (this.getOperatorDefaultRouter === 'Dashboard' || this.getOperatorDefaultRouter === '') {
			this.currentRouterPath = false;
		}

		window.addEventListener('scroll', throttle(this.on_scroll, 100));
	},
	watch: {
		'$route.path': function (val) {
			if (val === '/dashboard' || val === '/setting/accountsetting') {
				this.currentRouterPath = false;
				this.setBreadShow(false);
			} else {
				this.currentRouterPath = true;
				this.setBreadShow(true);
			}

			// 路由變化時關閉 alert
			if (this.alertShow) {
				this.closeAlert();
			}
		},
	},
};
</script>
